import { css } from 'styled-components';
import { fonts, colors, breakpoints } from '../../style-utilities/variables';
export default css`
  #shopping-button-right {
    left: -110px;
  }

  .top-bar {
    .person,
    .favorite {
      font-weight: bold;
      height: 3em !important;
      svg {
        path {
          fill: ${colors.primary} !important;
        }
      }
      a {
        color: ${colors.primary};
        margin-left: 5px;
      }
    }
    .favorite-count {
      color: #fff !important;
      background: ${colors.accent};
      top: -4px;
      left: -7px;
      text-align: center;
      font-size: 0.75em;
      border-radius: 50%;
      line-height: 18px;
      width: 18px;
      height: 18px;
    }
  }
  .shoppingList-title {
    font-family: ${fonts.primary}, 'sans-serif';
  }
  .main-list .add-shopping-list {
    margin-bottom: 0;
  }
  .add-shopping-list {
    background: #fff;
    font-weight: bold;
  }

  .bottom-bar {
    -ms-grid-columns: 50%;
    grid-template-columns: 50%;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    margin-top: 1em;
    .button {
      padding: 10px;
      background: #fff;
      &:nth-child(2) {
        display: none;
      }
    }
    @media (min-width: ${breakpoints.generalDesktop}) {
      -ms-grid-columns: 44% 1em 44%;
      grid-template-columns: repeat(2, 44%);
      grid-column-gap: 1em;
      .button {
        width: 90%;
        padding: 10px 5px;
        &:nth-child(2) {
          display: block;
        }
        &:hover {
          background: ${colors.primaryHover};
          color: ${colors.white};
          transition: background-color 0.3s ease-out;
        }
      }
    }
  }
  #shopping-button-right {
    left: -117px;
    border-bottom: 2px solid #fff;
  }
`;
